import React, { useEffect, useState } from 'react';
import { Box, Flex, Heading, Text, useTheme } from '@chakra-ui/react';
import { getTimeRemaining, hasISTTimestampPassed } from '../../utils/date';

const CountdownTimer = ({ type, setTimerEnd, setEndTimerEnded, date }: any) => {
	const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining(date));

	useEffect(() => {
		const timer = setInterval(() => {
			const time = getTimeRemaining(date);
			setTimeRemaining(time);
			if (time.total <= 0) {
				setTimerEnd(true);
				clearInterval(timer);
			} else {
				setTimerEnd(false);
			}
		}, 1000);
		return () => clearInterval(timer);
	}, [date]);

	return (
		// <Flex mx="auto" justifyContent={'center'}>
		<Box mt="16px">
			<Box>
				<Text textStyle={'body2-md'} color="#544D4F">
					{type === 'start' ? 'Test Starts in:' : 'Test Ends in:'}
				</Text>
			</Box>

			<Flex mt="8px" ml="-16px">
				{timeRemaining.days !== '00' && (
					<>
						<Box className="time-section" textAlign="center" mx={4}>
							<Text
								display={{
									base: 'none',
									md: 'block',
								}}
								textStyle={'body2-md'}
								fontSize={'16px'}
								color="#4358F6"
							>
								{hasISTTimestampPassed(date) ? '00' : timeRemaining.days}
								{' d'}
							</Text>
							<Text
								display={{
									base: 'block',
									md: 'none',
								}}
								textStyle={'body2-md'}
								fontSize={'16px'}
								color="#4358F6"
							>
								{hasISTTimestampPassed(date) ? '00' : timeRemaining.days}
								{' d'}
							</Text>

							{/* <Text textStyle={{ base: 'body2-md', md: 'body1-md' }}>days</Text> */}
						</Box>
						<Text
							display={
								{
									// base: 'none',
									// md: 'block',
								}
							}
							textStyle={'body2-md'}
							fontSize={'16px'}
							color="#4358F6"
							alignSelf={'self-start'}
						>
							:
						</Text>
					</>
				)}

				<Box className="time-section" textAlign="center" mx={4}>
					<Text
						display={{
							base: 'none',
							md: 'block',
						}}
						textStyle={'body2-md'}
						fontSize={'16px'}
						color="#4358F6"
					>
						{hasISTTimestampPassed(date) ? '00' : timeRemaining.hours}
						{' h'}
					</Text>
					<Text
						display={{
							base: 'block',
							md: 'none',
						}}
						textStyle={'body2-md'}
						fontSize={'16px'}
						color="#4358F6"
					>
						{hasISTTimestampPassed(date) ? '00' : timeRemaining.hours}
						{' h'}
					</Text>
					{/* <Text textStyle={{ base: 'body2-md', md: 'body1-md' }}>hours</Text> */}
				</Box>
				<Text
					display={
						{
							// base: 'none',
							// md: 'block',
						}
					}
					textStyle={'body2-md'}
					fontSize={'16px'}
					color="#4358F6"
					alignSelf={'self-start'}
				>
					:
				</Text>
				<Box className="time-section" textAlign="center" mx={4}>
					<Text
						display={{
							base: 'none',
							md: 'block',
						}}
						textStyle={'body2-md'}
						fontSize={'16px'}
						color="#4358F6"
					>
						{hasISTTimestampPassed(date) ? '00' : timeRemaining.minutes}
						{' m'}
					</Text>
					<Text
						display={{
							base: 'block',
							md: 'none',
						}}
						textStyle={'body2-md'}
						fontSize={'16px'}
						color="#4358F6"
					>
						{hasISTTimestampPassed(date) ? '00' : timeRemaining.minutes}
						{' m'}
					</Text>
					{/* <Text textStyle={{ base: 'body2-md', md: 'body1-md' }}>minutes</Text> */}
				</Box>
				<Text
					display={
						{
							// base: 'none',
							// md: 'block',
						}
					}
					textStyle={'body2-md'}
					fontSize={'16px'}
					color="#4358F6"
					alignSelf={'self-start'}
				>
					:
				</Text>
				<Box className="time-section" textAlign="center" mx={4}>
					<Text
						display={{
							base: 'none',
							md: 'block',
						}}
						textStyle={'body2-md'}
						fontSize={'16px'}
						color="#4358F6"
					>
						{hasISTTimestampPassed(date) ? '00' : timeRemaining.seconds}
						{' s'}
					</Text>
					<Text
						display={{
							base: 'block',
							md: 'none',
						}}
						textStyle={'body2-md'}
						fontSize={'16px'}
						color="#4358F6"
					>
						{hasISTTimestampPassed(date) ? '00' : timeRemaining.seconds}
						{' s'}
					</Text>
					{/* <Text textStyle={{ base: 'body2-md', md: 'body1-md' }}>seconds</Text> */}
				</Box>
			</Flex>
		</Box>
	);
};

export default CountdownTimer;
